import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-multi-plan-navigation',
  imports: [RouterOutlet],
  templateUrl: './multi-plan-navigation.component.html',
  styleUrl: './multi-plan-navigation.component.scss',
})
export class MultiPlanNavigationComponent {}
